import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 10,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  header: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: "space-between",
  },
  title: {
    fontFamily: 'Times-Bold',
    fontSize: 14,
    textTransform: 'capitalize',
  },
  text: {
    fontFamily: 'Times-Bold',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 900,
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCol: {
    width: '50%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    height: '22px',
  },
  tableCol4: {
    width: '25%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    height: '22px',
  },
  tableCol2: {
    width: '70%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    height: '22px',
  },
  tableCol3: {
    width: '20%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    height: '22px',
  },
  tableCell: {
    marginLeft: 10,
    marginTop: 5,
    fontSize: 10,
    height: '22px',
    textAlign: 'left',
  },
  tableCellBold: {
    marginLeft: 10,
    marginTop: 5,
    textAlign: 'left', 
    fontSize: 10,
    height: '22px',
  },
  twoColumnContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    textAlign: "left",
    marginTop: "10",
  },
  leftColumn: {
    width: '50%',
  },
  rightColumn: {
    width: '50%',
  },
  spacing: {
    width: '10%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderTopWidth: 0,
  }
});

const TrialStatisticsReports = ({ data }) => {
  const trialData = {
    trialStatistics: [
      { label: 'Grand Total', value: data.npfEntries}, 
      { label: 'Total Entries - NA&E', value: data.totalEntryNoPremier },
      { label: 'Total Premier Entries', value: data.totalEntries },
      { label: 'SIT Entries', value: data.sitEntries },
      { label: 'Total Standard Entries - NA&E', value: data.standardEntries },
      { label: 'Total Standard Entries - Premier', value: data.standardEntriesPremier },
      { label: 'Total Pro Entries - NA&E', value: data.proEntries },
      { label: 'Total FEO Entries - NA&E', value: data.feoEntries },
      { label: 'Total FEO Entries - Premier', value: data.feoEntriesPremier },
      { label: 'Premier Full Trial Entries', value: data.premierFul },
      { label: 'Premier Short Trial Entries', value: data.premierShort },
      { label: '', value: null},
      { label: 'Qs - Standard', value: data.qStandardEntries },
      { label: 'Qs - Pro', value: data.qProEntries },
      { label: 'Qs - FEO', value: data.qFeoEntries },
      { label: 'Pass Rate', value: data.passRate },
      { label: 'NQs', value: data.totalNQ },
      { label: 'False Alerts', value: data.falseAlert },
      { label: 'Time Outs', value: data.timedOut },
      { label: 'Hide Not Found', value: data.hideNotFound },
      { label: 'No Finish Call', value: data.noFinishCall },
      { label: 'Excused', value: data.excused },
      { label: 'Absent', value: data.absent },
      { label: 'Other', value: data.other },
      { label: '', value: null },
      { label: 'Total Golden Nose Awards', value: data.awards },
      { label: 'Total Element Titles', value: data.elementTitles },
      { label: 'Total Pro Titles', value: data.proTitles },
      { label: 'Total Novice Overall Titles', value: data.noviceOverallTitle },
      { label: 'Total Advanced Overall Titles', value: data.advancedOverallTitles },
      { label: 'Total Excellent Overall Titles', value: data.excellentOverallTitles },
      { label: 'Total Premier Titles', value: data.premierTitles },
      { label: 'Total Champion Titles', value: data.championTitles },
    ],
  };

  const maxRows = Math.max(trialData.trialStatistics.length, data.searchEntries.length);
  const padLeft = new Array(maxRows - trialData.trialStatistics.length).fill(null);
  const padRight = new Array(maxRows - data.searchEntries.length  - 1).fill(null);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <View style={styles.header}>
            <Text style={styles.title}>{data.trialName}, {data.trialLocation}</Text>
            <Text style={styles.text}>{moment.utc(data.date).format("MM/DD/YYYY")}</Text>
          </View>
          <Text style={styles.text}>Trial Statistics</Text>
          <View style={styles.twoColumnContainer}>
            <View style={styles.leftColumn}>
              <View style={styles.table}>
                {trialData.trialStatistics.map((item, index) => (
                  <View style={styles.tableRow} key={`left-${index}`}>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}>{item.label}</Text>
                    </View>
                    <View style={styles.tableCol3}>
                      <Text style={styles.tableCell}>{item.value}</Text>
                    </View>
                    <View style={styles.spacing}></View>
                  </View>
                ))}
                {padLeft.map((_, index) => (
                  <View style={styles.tableRow} key={`left-pad-${index}`}>
                    <View style={styles.tableCol2}>
                      <Text style={styles.tableCell}> </Text>
                    </View>
                    <View style={styles.tableCol3}>
                      <Text style={styles.tableCell}> </Text>
                    </View>
                    <View style={styles.spacing}></View>
                  </View>
                ))}
              </View>
            </View>
            <View style={styles.rightColumn}>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCellBold}>Search</Text>
                  </View>
                  <View style={styles.tableCol4}>
                    <Text style={styles.tableCellBold}>Entries</Text>
                  </View>
                  <View style={styles.tableCol4}>
                    <Text style={styles.tableCellBold}>Pass Rate</Text>
                  </View>
                </View>
                {data.searchEntries.map((item, index) => (
                  <View style={styles.tableRow} key={`right-${index}`}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{item.search}</Text>
                    </View>
                    <View style={styles.tableCol4}>
                      <Text style={styles.tableCell}>{item.entries}</Text>
                    </View>
                    <View style={styles.tableCol4}>
                      <Text style={styles.tableCell}>{item.passRate}</Text>
                    </View>
                  </View>
                ))}
                {padRight.map((_, index) => (
                  <View style={styles.tableRow} key={`right-pad-${index}`}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}> </Text>
                    </View>
                    <View style={styles.tableCol4}>
                      <Text style={styles.tableCell}> </Text>
                    </View>
                    <View style={styles.tableCol4}>
                      <Text style={styles.tableCell}> </Text>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default TrialStatisticsReports;
